var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.219 14.619a1.738 1.738 0 00-.132.165.836.836 0 00-.099.198.704.704 0 00-.066.198 1.496 1.496 0 000 .22.924.924 0 00.088.418.99.99 0 00.594.594c.266.118.57.118.836 0a.99.99 0 00.594-.594 1.1 1.1 0 00.066-.418 1.1 1.1 0 00-1.881-.781zM11 0C4.925 0 0 4.925 0 11s4.925 11 11 11 11-4.925 11-11A11 11 0 0011 0zm0 19.8a8.8 8.8 0 110-17.6 8.8 8.8 0 010 17.6zm0-14.3a3.3 3.3 0 00-2.86 1.65 1.1 1.1 0 101.903 1.1A1.1 1.1 0 0111 7.7a1.1 1.1 0 010 2.2A1.1 1.1 0 009.9 11v1.1a1.1 1.1 0 002.2 0v-.198A3.3 3.3 0 0011 5.5z",
    fill: "#009EE0",
    fillRule: "nonzero"
  })));
}
export default SvgIcoQuestion;